export class Popup {
  constructor () {
    this.dev = false
    this.popup = document.querySelector('.c-popup')
    this.popupClose = document.querySelector('.c-popup svg')

    if (this.popup) {
      this.popup.classList.add('is-active')
      this.popup.addEventListener('click', this.close.bind(this))
    }
  }

  close () {
    this.popup.classList.remove('is-active')
  }
}
